<template>
  <div class="flex space-x-4 animate-pulse" :class="{ withMargin: 'mt-8 mb-2' }">
    <div class="flex-1 space-y-2 py-1">
      <div class="h-4 bg-gray-200 rounded" />
      <div class="h-4 bg-gray-200 rounded" />
      <div class="h-4 bg-gray-200 rounded" />
      <div class="h-4 bg-gray-200 rounded w-3/4" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    withMargin: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
